<!--Copy right - © 2024 tecera gmbh-->

<script>
    import { get_compound_water_meter_csv_data } from "../../scripts/data.js";
    import { all_compound_water_meters, selected_device, all_hymos } from "../../stores.js";

    var end_date = moment(); // Now
    var start_date = moment().subtract(3, "days"); // 3 days ago
    var device_data = [];
    var sum_device_data = [];
    export let is_disabled = false;
    export let modal_toggle=false;

    async function download_csv() {
        const data = await get_compound_water_meter_csv_data(
            $selected_device.id,
            start_date,
            end_date,
        );
        device_data = data[0];
        sum_device_data = data[1];
        create_csv();
    }

    /**
     * Function to format a timestamp to a date string and also get its datecomponents.
     * @param {timestamp} timestamp - a timestamp that should be formatted
     * @returns {Object} - An Object containing the formatted time, aswell as each date component
     */
    function formate_date_to_dict(timestamp) {
        let date = new Date(timestamp);
        let day = String(date.getDate()).padStart(2, "0");
        let month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based in JS
        let year = date.getFullYear();
        let hours = String(date.getHours()).padStart(2, "0");
        let minutes = String(date.getMinutes()).padStart(2, "0");
        return {
            date: date,
            formatted:
                day + "." + month + "." + year + " " + hours + ":" + minutes,
            day: day,
            month: month,
            year: year,
            hour: hours,
        };
    }

    function create_csv() {
        let headers = ["MET/MEST", "longtime", "hour", "day", "month", "year"];
        let timestamps = [];
        let rows = [];
        device_data.forEach((data, idx2) => {
            headers.push(
                data.device_config.name +
                    " Zaehlerstand " +
                    data.device_config.alt_id,
            );
            headers.push(
                data.device_config.name +
                    " Volumenstrom " +
                    data.device_config.alt_id,
            );
        });
        device_data[0].data.forEach((data, idx) => {
            let date_parts = formate_date_to_dict(data["received_at"]);
            let date = date_parts.formatted;
            // Convert to long time format (milliseconds since the Unix epoch)
            let receivedAtLongTime = date_parts.date.getTime();
            let datapoints = [];
            device_data.forEach((data2) => {
                datapoints.push(
                    data2.data[idx]["meter_reading"]
                        .toString()
                        .replace(/\./g, ",") +
                        ";" +
                        (data2.data[idx]["volume_flow"]
                            ? data2.data[idx]["volume_flow"]
                                  .toString()
                                  .replace(/\./g, ",")
                            : "0"),
                );
            });
            if (sum_device_data.length > 0) {

                datapoints.push(
                    sum_device_data[idx]["meter_reading_sum"]
                        .toString()
                        .replace(/\./g, ",") +
                        ";" +
                        sum_device_data[idx]["volume_flow_sum"]
                            .toString()
                            .replace(/\./g, ","),
                );
            }
            let row =
                date +
                ";" +
                receivedAtLongTime +
                ";" +
                date_parts.hour +
                ";" +
                date_parts.day +
                ";" +
                date_parts.month +
                ";" +
                date_parts.year +
                ";" +
                datapoints.join(";");

            rows.push(row);
        });

        if (sum_device_data.length > 0) {
            headers.push(
                device_data[0].device_config.name + " Zaehlerstand Gesamt",
            );
            headers.push(
                device_data[0].device_config.name + " Volumenstrom Gesamt",
            );
        }
        const csvHeader = headers.join(";") + "\n";

        const csvContent = csvHeader + rows.join("\n");

        const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
        });
        const url = URL.createObjectURL(blob);

        // Create an anchor element and set properties for downloading
        let downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.download = "export.csv";

        // Programmatically click the anchor to trigger the download
        downloadLink.click();

        // Cleanup: revoke the object URL to free up resources
        URL.revokeObjectURL(url);
    }

    $: {
if ($selected_device && $selected_device.box_id || ($all_compound_water_meters.length == 0 && $all_hymos.length == 0)) {
    is_disabled = true;
} else {
    is_disabled = false;
}
}
</script>

<div class="btn-distance">
    <button
        type="button"
        class="btn btn-outline-secondary"
        id="linkCSV"
        disabled={is_disabled}
        on:click={()=>modal_toggle=true}><i class="fa fa-download"></i></button
    >
</div>
